import { useParams } from 'react-router-dom';

import { AppAddUserPage } from '~/components/pages/AppAddUserPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppAddUserRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppAddUserPage appId={appId} />
    </DashboardTemplate>
  );
};
